import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  100% {
    transform: rotate(1turn);
  }
`;

const SpinnerContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #774eff 94%, #0000) top/3.8px 3.8px no-repeat,
    conic-gradient(#0000 30%, #774eff);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 3.8px), #000 0);
  animation: ${spin} 1s infinite linear;
`;

interface LoadingSpinnerProps {
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
  return <SpinnerContainer className={className} />;
};
